import { Layout } from '../models/layout';
import { GuardedRouteMeta } from '../models/route';

export const defaultGuardedRouteMeta: GuardedRouteMeta = {
  loggedIn: true,
  layout: Layout.SIDE_NAVIGATION,
};
